const noopPromiseBasedActionGenerator = ($q, resolved = '-saved-') => () => {
  const result = $q.defer()
  result.resolve(resolved)
  return result.promise
}

export default noopPromiseBasedActionGenerator
